export default __webpack_public_path__ + "static/media/CodingCoachImage.ee582913.png";